<template>
	<div class="full-height">
		<Header></Header>
		<div class="flex-center">
			<div class="main-container">
				<div class="nav-bar">
					<span>
						当前位置：
						<a href="/">首页</a>
						<span> > </span>
						<a href="/rmjz">融媒矩阵</a>
					</span>
				</div>

				<div class="flex" style="min-height: 400px;justify-content: center;width: 100%;">
					<div>
						<h1 ref="title" class="rmjz-title">晋冀鲁豫烈士陵园融媒矩阵</h1>

						<div v-for="list in codes" class="flex-center">
							<div v-for="item in list">
								<div class="code-img-container">
									<img class="code-img" :src="item.src" />
								</div>
								<p class="code-word">{{item.title}}</p>
							</div>

						</div>
					</div>

				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../../components/Header';
	import Footer from '../../../components/Footer';
	import api from '../../../http/detail'
	export default {
		components: {
			Header,
			Footer
		},
		data() {
			return {
				codes: [
					// 四个为一组
					[{
							src: "/static/img/rmjz/dy.jpg",
							title: "抖音"
						},
						{
							src: "/static/img/rmjz/wx1.jpg",
							title: "晋冀鲁豫英烈纪念园"
						},
						{
							src: "/static/img/rmjz/wx2.jpg",
							title: "晋冀鲁豫烈士陵园"
						},
						{
							src: "/static/img/rmjz/wb.jpg",
							title: "微博"
						}
					],
					[],
				]
			}
		},
		methods: {

		},
		created() {
			
		},
		mounted() {
			this.$refs.title.scrollIntoView()
		}
	}
</script>

<style scoped>
	.art-title {
		height: 21px;
		font-size: 20px;
		font-family: Microsoft YaHei;
		font-weight: bold;
		color: #333333;
		line-height: 21px;
	}

	.main-container {
		width: 1200px;
	}

	.nav-bar {
		text-align: left;
		width: 100%;
		height: 16px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #333333;
		margin: 23px 0;
	}

	.rmjz-title {
		text-align: center;
		font-size: 30px;
		color: #3e3a39;
		margin-bottom: 20px;
	}

	.code-img {
		max-width: 100%;
		height: 100%;
	}

	.code-img-container {
		width: 175px;
		height: 175px;
		margin: 10px 30px;
	}

	.code-word {
		font-size: 20px;
		line-height: 36px;
		text-indent: 0;
		text-align: center;
	}
</style>



// WEBPACK FOOTER //
// src/views/detail/rongmei/index.vue